import React from "react";
import BaseField from "./BaseField";

export default function YesNoField({
  field,
  value,
  setValue,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  const required = !!field.required;
  const label = field.label || "Yes / No";
  const yesColor = field.config?.yesColor || "#22c55e";
  const noColor = field.config?.noColor || "#ef4444";

  const answer = value?.answer ?? "";

  function choose(opt) {
    setValue({ ...(value || {}), answer: opt });
  }

  return (
    <BaseField
      field={field}
      value={value}
      setValue={setValue}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      {/* Label */}
      <h3 className="text-gray-800 dark:text-gray-100 text-lg font-bold mb-3 text-center">
        {label} {required && <span className="text-orange-500">*</span>}
      </h3>

      {/* Yes/No buttons */}
      <div className="flex gap-4 justify-center mt-1">
        {["yes", "no"].map((opt) => {
          const active = answer.toLowerCase() === opt;
          const accent = opt === "yes" ? yesColor : noColor;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => choose(opt)}
              className={`px-5 py-3 rounded-lg border font-semibold text-base transition-colors ${
                active
                  ? "text-white"
                  : "border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100"
              }`}
              style={
                active
                  ? { backgroundColor: accent, borderColor: accent }
                  : {}
              }
            >
              {opt === "yes" ? "✅ Yes" : "❌ No"}
            </button>
          );
        })}
      </div>

      {/* Optional follow-up text */}
      <div className="mt-4 pt-3 border-t border-gray-400 dark:border-gray-600">
        <input
          type="text"
          value={value?.followUp ?? ""}
          onChange={(e) =>
            setValue({ ...(value || {}), followUp: e.target.value })
          }
          placeholder="Additional comments..."
          className="w-full border-2 border-orange-500 rounded-lg p-3 bg-white dark:bg-gray-700 text-center text-base text-gray-800 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-orange-400"
        />
      </div>
    </BaseField>
  );
}
